import { __decorate, __extends } from "tslib";
import { CustomElement, attachShadowTemplate } from '@tyler-components-web/core';
import { INLINE_MESSAGE_CONSTANTS } from './inline-message-constants';
var template = require('./inline-message.html');
var styles = require('./inline-message.css');
var InlineMessageComponent = /** @class */ (function (_super) {
    __extends(InlineMessageComponent, _super);
    function InlineMessageComponent() {
        var _this = _super.call(this) || this;
        attachShadowTemplate(_this, INLINE_MESSAGE_CONSTANTS.elementName, template, styles);
        return _this;
    }
    InlineMessageComponent = __decorate([
        CustomElement({
            name: INLINE_MESSAGE_CONSTANTS.elementName
        })
    ], InlineMessageComponent);
    return InlineMessageComponent;
}(HTMLElement));
export { InlineMessageComponent };
